export default __webpack_public_path__ + "static/media/MAXIS_4.a90ad188.gif";